import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Card from '../components/Card';
import SpeakerDoc from './SpeakerDoc';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyImage from '../../CustomLibraries/LazyImage';
import dayjs from 'dayjs';
import { timeDifference } from '../../../common/common';
import { default_images } from '../../../common/defaultImages';
import useRedirect from '../../customHooks/useRedirect';
import GetRecordingModal from '../../modals/uiv3/GetRecordingModal';
import { useAddSpecialityCMELike } from '../../../Queries/QueryHooks/session.hook';

import useShare from '../../customHooks/useShare';
import ReportContentPopover from './components/ReportContentPopover';
import CpdPoint from '../../cards/session/sessionCardV1/components/CpdPoint';
import { removeHtmlTags } from '../../../pages/channel/utils';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import TooltipContainer from '../components/TooltipContainer';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
const CMECard = (data) => {
  const {
    type = '',
    navType = '',
    className = '',
    click,
    sponsorLogo,
    sessionDoctorEntities,
    startDateTime,
    endDateTime,
    id,
    title,
    specialities,
    deeplink,
    moduleType,
    image,
    likeCount,
    participantCount,
    viewCount,
    masterCast,
    specialities_ids_and_names,
    cpdDetails,
    featured = false,
    selectedSubNavItem
  } = data || {};
  const share_url = useShare();
  const { redirectTo } = useRedirect();
  const sponsor_logo = sponsorLogo ? sponsorLogo.split(',') : [];
  const sessionDoctorDetails = sessionDoctorEntities ?? [];
  // const [sponsor_logo, setSponsor_Logo] = useState((sponsorLogo && sponsorLogo.split(',')) ?? []);
  // const [sessionDoctorDetails, setSessionDoctorDetails] = useState(sessionDoctorEntities ?? []);
  const [show, setShow] = useState(false);
  const modalClose = useCallback(
    (data) => {
      setShow(data);
    },
    [show]
  );
  let isLiveStart =
    startDateTime && endDateTime
      ? timeDifference(startDateTime) >= 0 && timeDifference(endDateTime) <= 0
      : false;
  const calculateTimeLeft = () => {
    const datetime = dayjs(startDateTime).diff(dayjs(new Date()));
    let timeLeft = {};

    if (datetime > 0) {
      timeLeft = {
        days: Math.floor(datetime / (1000 * 60 * 60 * 24)),
        hours: Math.floor((datetime / (1000 * 60 * 60)) % 24)
      };
    }

    return timeLeft;
  };
  const getFormatedData = (val = 0) => {
    if (val > 0) {
      return val.toString().padStart(2, 0);
    } else {
      return val.toString().padStart(2, 0);
    }
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  const cmeCoverImageHandler = () => {
    console.group('cmeCoverImageHandler');
    console.log('image', image);
    console.groupEnd('cmeCoverImageHandler');
    if (image && image?.length != 0) {
      try {
        let imgArr = JSON.parse(image);
        let imageSelector =
          imgArr && imgArr?.length > 0 ? imgArr?.filter((i) => i?.length != 0) : [];
        return imageSelector.length > 0 ? imageSelector[0] : '';
      } catch {
        try {
          let imgArr = image?.replace(/[\[\]'""]/g, '')?.split(',');
          let imageSelector =
            imgArr && imgArr?.length > 0 ? imgArr?.filter((i) => i?.length != 0) : [];
          return imageSelector.length > 0 ? imageSelector[0] : '';
        } catch {
          return '';
        }
      }
    } else {
      return '';
    }
  };
  const cardClick = () => (click ? click() : redirectTo('SessionDetails', id));
  const onLikePress = () => {
    saveLike({ type: 'session', type_id: id });
    // alert(id);
  };

  // HOOKS
  const { mutate: saveLike } = useAddSpecialityCMELike(id);

  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { master_specialities_id, specialities_name } = specialities_ids_and_names[0];
      redirectTo('Speciality', master_specialities_id, specialities_name);
    }
  };
  const { userActivityTracker } = useTrackUserActivity();

  return (
    <>
      <Card
        className={`clr_v3_card__CME ${className ?? ''} ${featured && 'clr_v3_card__featured'}`}
        type={type}
      >
        {/* comments and post by at top*/}
        {/* <CommentsAtTop /> */}
        {featured && (
          <span className="clr_v3_card__featured__tag bg-primary rounded-pill position-absolute text-white">
            <i className="clr_v3_card__featured__icon translate-middle start-50 top-50 position-absolute">
              <i className="flaticon-danger fs-1"></i>
            </i>
          </span>
        )}
        <Card.Body>
          <Card.Header className="">
            {masterCast && (
              <span className="me-auto d-inline-flex align-items-center gap-2">
                <i class="flaticon-video-camera fs-2 text-primary"></i>
                <span>{masterCast}</span>
              </span>
            )}
            <InView
              className="ms-auto align-items-center d-flex gap-sm-3 gap-2"
              as="div"
              onChange={(inView) => {
                userActivityTracker(inView, { ...data, type: 'session', session_id: id }, 'card');
              }}
            >
              {isLiveStart && (
                <span className="text-danger fw-semibold fs-4 me-auto d-inline-flex align-items-center">
                  <div className="pulseCircle me-2"></div> Live
                </span>
              )}

              {title && deeplink ? (
                <TooltipContainer text="Share">
                  <span
                    className="icon-size-32 icon-size-sm-36 clr_v3_card__icon transition cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2 clr_v3_icon-btn-1"
                    onClick={() => {
                      share_url(title, deeplink);
                    }}
                  >
                    <i class="flaticon-share"></i>
                  </span>
                </TooltipContainer>
              ) : (
                <></>
              )}
              {/* <i class="flaticon-more-1 fs-1"></i> */}
              <ReportContentPopover type={moduleType} id={id} />
            </InView>
          </Card.Header>
          <div className="d-flex cursorPointer" onClick={cardClick}>
            <div className="flex-grow-1 d-flex justify-content-center flex-column">
              {title && <Card.Title className="hover-opacity">{removeHtmlTags(title)}</Card.Title>}
              {type == 'small' && (
                <span className="fs-4 mt-2 text-dark fw-normal">
                  {dayjs(startDateTime).format('ddd')}, {dayjs(startDateTime).format('MMM DD, YY')}{' '}
                  - {dayjs(startDateTime).format('h:mm a')}{' '}
                </span>
              )}
            </div>
          </div>
          {sessionDoctorDetails && sessionDoctorDetails?.length > 0 && (
            <SpeakerDoc data={sessionDoctorDetails} />
          )}
          {type !== 'small' && (
            <Card.Image className="mt-4 position-relative">
              <LazyImage
                src={image}
                alt="cover image"
                fallback_image={default_images?.session}
                className={`object-fit-cover w-100 h-100 cursorPointer`}
                onClick={cardClick}
                extraClass="hover-image w-100 h-100 position-relative"
              />

              <div
                className="d-flex align-items-end p-md-4 p-3 z-1 justify-content-between text-white overlay"
                onClick={cardClick}
              >
                {startDateTime && (
                  <h5 className="fs-3 fw-semibold">
                    {dayjs(startDateTime).format('ddd')},{' '}
                    {dayjs(startDateTime).format('MMM DD, YY')} -{' '}
                    {dayjs(startDateTime).format('h:mm a')}{' '}
                  </h5>
                )}
                {timeLeft?.days > 0 && (
                  <h5 className="fs-3 fw-semibold text-end">
                    <span className="d-block fw-normal fs-4">Remaining</span>{' '}
                    {`${getFormatedData(timeLeft.days)}d : ${getFormatedData(timeLeft.hours)}h`}
                  </h5>
                )}
              </div>
              <CpdPoint data={{ cpddetail: cpdDetails }} />
            </Card.Image>
          )}
          {navType !== 'Watch' && (
            <div className="mt-4 d-flex gap-3 flex-wrap">
              {selectedSubNavItem !== 'recorded' ? (
                <Card.Button className="btn-outline-primary" onClick={cardClick}>
                  Attend
                </Card.Button>
              ) : (
                <></>
              )}

              <Card.Button className="btn-primary" onClick={() => setShow(true)}>
                Get Recording
              </Card.Button>
            </div>
          )}
          <Card.Footer>
            <div className="me-auto d-flex align-items-center flex-grow-1">
              {/* <span
                className="clr_v3_card__icon text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center"
                onClick={onLikePress}
              >
                <i class="flaticon-heart-1 me-2 fs-2"></i>
                {likeCount && <span>{likeCount}</span>}
              </span> */}
              {/* <span className="clr_v3_card__icon text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center">
                <i class="flaticon-oval-black-speech-bubble me-2 fs-2"></i>
                {data && data.comment_count && <span>{data?.comment_count}</span>}
              </span> */}
              {/* <span
                title="Participants"
                className="clr_v3_card__icon text-dark py-1 d-inline-flex align-items-center justify-content-center"
              >
                <i class="flaticon-user me-2 fs-2"></i>
                <span>{participantCount ?? 0}</span>
              </span> */}
            </div>

            {sponsor_logo && sponsor_logo?.length > 0 ? (
              <Swiper
                className="clr_v3_sponsor text-right me-0"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsor_logo &&
                  sponsor_logo?.length > 1 &&
                  sponsor_logo?.map((_sp, idx) => (
                    <SwiperSlide
                      key={idx + 1}
                      className="clr_v3_sponsor_slide w-100 position-relative"
                    >
                      <LazyImage
                        src={_sp}
                        alt="sponsor"
                        className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                        logo
                      />
                    </SwiperSlide>
                  ))}
                {sponsor_logo &&
                  sponsor_logo?.length == 1 &&
                  sponsor_logo?.map((_sp, idx) => (
                    <div key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                      <LazyImage
                        src={sponsor_logo[0]}
                        alt="sponsor"
                        className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                        logo
                      />
                    </div>
                  ))}
              </Swiper>
            ) : (
              <div className="clr_v3_sponsor_slide w-100 position-relative"></div>
            )}
          </Card.Footer>
        </Card.Body>
        {/* card comments end */}
        {/* <CommentsAtEnd /> */}
      </Card>
      <GetRecordingModal id={id} show={show} close={modalClose} />
    </>
  );
};

CMECard.propTypes = propTypes;
CMECard.defaultProps = defaultProps;
// #endregion

export default memo(CMECard);
